// extracted by mini-css-extract-plugin
export default {"headline":"YFXpUp_GO36l7D5uHSrk"};